import { Component, OnInit } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';
import { SME_LESSON_GUIDE_ASSET } from '@app/constants/sme-help-doc';
import { markdownLiteToHtml } from '@app/utils/markdown-lite';

@Component({
  selector: 'app-sme-help-guide',
  templateUrl: './sme-help-guide.component.html',
  styleUrls: ['./sme-help-guide.component.scss'],
})
export class SMEHelpGuideComponent implements OnInit {
  loading = true;
  error = '';
  html: SafeHtml | null = null;

  constructor(
    private http: HttpClient,
    private sanitizer: DomSanitizer,
  ) {}

  ngOnInit(): void {
    this.http.get(SME_LESSON_GUIDE_ASSET, { responseType: 'text' }).subscribe({
      next: (md) => {
        const body = stripSyncCommentBlock(md);
        this.html = this.sanitizer.bypassSecurityTrustHtml(markdownLiteToHtml(body));
        this.loading = false;
      },
      error: () => {
        this.error = 'Could not load the help guide. Ask your administrator to rebuild the app after updating docs/sme-new-lesson-guide.md.';
        this.loading = false;
      },
    });
  }
}

/** Hide HTML comment at top of canonical doc (editor / sync note). */
function stripSyncCommentBlock(md: string): string {
  return md.replace(/^<!--[\s\S]*?-->\s*/u, '');
}
